import { SearchSuggestionsType } from '$util/types';
import { PreloadImage } from '$util/PreloadImage';
import Grid from '$components/layout/Grid';
import { nutHeaderSrc } from '$layout/partials/TopBackground';
import { Card } from '$components/basic/Card';
import { TextHighlight } from '$components/basic/TextHighlight';
import { SearchTopCard } from '$components/common/SearchTopCard';
import { Title } from '@/components/atoms/Title';
import { Styled } from './styled';

const { Row, Col } = Grid;

export function OurServicesTopSection() {
  return (
    <Styled className="OurServicesTopSection">
      <PreloadImage provider="cloudinary" href={nutHeaderSrc} displayFrom="lg" />

      <Row className="top-wrapper">
        <Col span={12}>
          <header>
            <Title h={1} size="xl">
              <strong>Save up to 30%</strong> on services and repairs
            </Title>
            <Title h={2} size="md">
              <span>
                From MOTs to repairs and replacements,
                <br />
              </span>
              we offer the best value car maintenance around.
            </Title>
          </header>
          <Card className="search-card">
            <TextHighlight>What service or repair does your car need?</TextHighlight>
            <SearchTopCard
              id="OurServicesSearch"
              type={SearchSuggestionsType.PRODUCT}
              placeholder="eg: Brake"
            />
          </Card>
        </Col>
      </Row>
    </Styled>
  );
}
OurServicesTopSection.displayName = 'OurServicesTopSection';

export default OurServicesTopSection;
